export default {
  active: 'Du er medlem ut %{semester} %{year}',
  keyInfo: 'Ønsker du nøkkel til kjelleren? Se mer info på wikien vår:',
  inactive:
    'Du har ikke betalt medlemsavgiften. Hvis du nettopp har betalt, vil det ta litt tid før dette oppdateres.',
  logout: 'Logg ut',
};
